import Logo from "../../Assets/images/slogan/connectcaremintgreen.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes, faUser} from "@fortawesome/free-solid-svg-icons";
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from '@headlessui/react'
import {useState} from "react";
import {Link} from "react-router-dom";
import {ProfileButton} from "./ProfileButton";

export const AdminMobileNavigation = (props) => {
    const {
        menuItems,
        isCurrentActive,
        profileLinks
    } = props;

    const [open, setOpen] = useState(false)
    const genericHamburgerLine = `h-1 w-6 my-1 rounded-full bg-black transition ease transform duration-300`;

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    return (
        <header className="bg-white rounded-full mb-2 py-2 container mx-auto mt-4">
            <div className="mx-auto px-4 flex items-center justify-between">
                <div className="text-xl font-bold text-gray-700">
                    <img src={Logo} alt={'Logo for connect care mint green'} className={'max-h-10 mx-auto'}/>
                </div>

                <div className="relative flex flex-row space-x-3">
                    <div>
                        <button
                            className="flex flex-col h-12 w-12 rounded justify-center items-center group"
                            onClick={() => setOpen(!open)}
                        >
                            <div
                                className={`${genericHamburgerLine} ${
                                    open
                                        ? "rotate-45 translate-y-3 opacity-50 group-hover:opacity-100"
                                        : "opacity-50 group-hover:opacity-100"
                                }`}
                            />
                            <div
                                className={`${genericHamburgerLine} ${
                                    open ? "opacity-0" : "opacity-50 group-hover:opacity-100"
                                }`}
                            />
                            <div
                                className={`${genericHamburgerLine} ${
                                    open
                                        ? "-rotate-45 -translate-y-3 opacity-50 group-hover:opacity-100"
                                        : "opacity-50 group-hover:opacity-100"
                                }`}
                            />
                        </button>
                    </div>

                    <ProfileButton
                        menuItems={profileLinks}
                    />
                </div>
            </div>


            <Dialog className="relative z-50" open={open} onClose={setOpen}>
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
                />

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                            <DialogPanel
                                transition
                                className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                            >
                                <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                    <div className="px-4 sm:px-6">
                                        <div className="flex items-start justify-between">
                                            <DialogTitle className="text-base font-semibold leading-6 text-gray-900">
                                                <img src={Logo} alt={'Logo for connect care mint green'} className={'max-h-10 mx-auto'}/>
                                            </DialogTitle>
                                            <div className="ml-3 flex h-7 items-center">
                                                <button
                                                    type="button"
                                                    className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                                                    onClick={() => setOpen(false)}
                                                >
                                                    <span className="absolute -inset-2.5" />
                                                    <span className="sr-only">Close panel</span>
                                                    <FontAwesomeIcon icon={faTimes} className="h-6 w-6" aria-hidden="true" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="relative mt-6 flex-1 px-4 sm:px-6">

                                        <nav className="flex flex-1 flex-col" aria-label="Sidebar">
                                            <ul role="list" className="-mx-2 space-y-1">
                                                {menuItems.map((item) => (
                                                    <li key={item.title}>
                                                        <Link
                                                            to={item.link}
                                                            onClick={() => setOpen(false)}
                                                            className={classNames(
                                                                isCurrentActive(item.link) ? 'bg-gray-50 text-secondary' : 'text-gray-700 hover:bg-gray-50 hover:text-secondary',
                                                                'group flex gap-x-3 rounded-md p-2 pl-3 text-sm font-semibold leading-6',
                                                            )}
                                                        >
                                                            {item.title}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </nav>

                                    </div>
                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </div>
            </Dialog>


        </header>
    )
}